import React, { useEffect } from 'react';
import { ConfirmModalProvider, Toaster } from "@td/ui";
import ProviderPanelsProvider, { useProviderPanels } from "./contexts/provider-panels-context";
import ModalsProvider, { useModals } from "./contexts/modals-context";
import StatesProvider from "./contexts/states-context";
import PracticeTeamsProvider from "./contexts/practice-teams-context";
import ListViewToolbar from "./containers/ListViewToolbar";
import ListView from "./containers/ListView";
import ListViewPagination from "./containers/ListViewPagination";
import Filters from "./containers/Filters";
import { useComponentInitializer } from './hooks';

const ProviderPanel = () => {
  const { openModal } = useModals();
  const { fetchProviderPanels, initializing, pageParams, filters, specialtyCode } = useProviderPanels();
  const initialize = useComponentInitializer();

  useEffect(() => {
    initialize();
  }, [specialtyCode]);

  useEffect(() => {
    if (!initializing) {
      fetchProviderPanels();
    }
  }, [initializing, pageParams, filters, specialtyCode]);

  return (
    <div>
      <Filters />
      <ListViewToolbar />
      <ListView />
      <ListViewPagination />
      <Toaster />
    </div>
  );
};

const ProviderPanelContainer = ({ specialty, enableStoredPreferences, ...props }) => (
  <ProviderPanelsProvider
    specialtyCode={specialty}
    enableStoredPreferences={enableStoredPreferences}
  >
    <PracticeTeamsProvider>
      <StatesProvider>
        <ConfirmModalProvider>
          <ModalsProvider>
            <ProviderPanel {...props} />
          </ModalsProvider>
        </ConfirmModalProvider>
      </StatesProvider>
    </PracticeTeamsProvider>
  </ProviderPanelsProvider>
);

export default ProviderPanelContainer;
